import React from 'react';
import { Col, Row } from 'antd';
import CountUp from 'react-countup';
import {
  CheckCircleOutlined,
  DeploymentUnitOutlined,
  EnvironmentOutlined,
  ThunderboltOutlined,
} from '@ant-design/icons';
import AnalyticsCard from './index';

type HeadlineStatsProps = {
  numberOfRoutes: number;
  numberOfLocations: number;
  fuelSaving: number;
  routeAdherence: string;
};

const HeadlineStats = ({
  numberOfRoutes,
  numberOfLocations,
  fuelSaving,
  routeAdherence,
}: HeadlineStatsProps): JSX.Element => (
  <Row gutter={[16, 16]} className="d-flex f-row f-nowrap pd-5">
    <Col span={8}>
      <AnalyticsCard
        value={<CountUp start={0} end={numberOfRoutes} duration={2} separator="," delay={0} />}
        description="Routes"
        percentageChange="12"
        icon={<DeploymentUnitOutlined className="analytics-card-icon c-blue" />}
      />
    </Col>
    <Col span={8}>
      <AnalyticsCard
        value={<CountUp start={0} end={numberOfLocations} duration={2} separator="," delay={0} />}
        description="Locations"
        percentageChange="28"
        icon={<EnvironmentOutlined className="analytics-card-icon c-green" />}
      />
    </Col>
    <Col span={8}>
      <AnalyticsCard
        value={<CountUp start={0} end={fuelSaving} duration={2} decimals={2} suffix=" L" delay={0} />}
        description="Fuel Saving"
        percentageChange="28"
        icon={<ThunderboltOutlined className="analytics-card-icon c-orange" />}
      />
    </Col>
    <Col span={8}>
      <AnalyticsCard
        value={routeAdherence}
        description="Route Adherence"
        percentageChange="20"
        icon={<CheckCircleOutlined className="analytics-card-icon c-cyan" />}
      />
    </Col>
  </Row>
);

export default HeadlineStats;
